import request from '@/utils/request'

export const getAuthorizedRouter = () =>
  request({
    url: '/routers/authorized',
    method: 'get'
  })

export const listRouter = (search) =>
  request({
    url: '/routers/list',
    method: 'get',
    params: {
      name: search.name,
      pageNum: search.currentPage,
      pageSize: search.limit
    }
  })

export const getRouterById = (id) =>
  request({
    url: '/routers/detail?id=' + id,
    method: 'get'
  })

export const listByParentId = (parentId) =>
  request({
    url: '/routers/search',
    method: 'get',
    params: {
      parentId: parentId
    }
  })

export const saveRouter = (router) =>
  request({
    url: '/routers/save',
    method: 'post',
    data: router
  })

export const updateRouter = (id, router) =>
  request({
    url: '/routers/' + id,
    method: 'put',
    data: router
  })

export const removeRouter = (id) =>
  request({
    url: '/routers/delete',
    method: 'post',
    data:{id: id}
  })

export const listAllRouter = (includeLocked) =>
  request({
    url: '/routers/all?includeLocked=' + includeLocked,
    method: 'get'
  })



// WEBPACK FOOTER //
// ./src/api/admin/router.js